import React from 'react';
import {
  Box, Typography, Grid, Card, CardActionArea, CardContent
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import ChecklistIcon from '@mui/icons-material/Checklist';
import InsightsIcon from '@mui/icons-material/Insights';
import TuneIcon from '@mui/icons-material/Tune';
import BarChartIcon from '@mui/icons-material/BarChart';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import CommentIcon from '@mui/icons-material/Comment';

const acciones = [
  { titulo: 'Crear Autoevaluación', ruta: '/crear-autoevaluacion', icono: <AssignmentIndIcon color="primary" /> },
  { titulo: 'Crear Evaluación', ruta: '/crear-evaluacion', icono: <AssignmentIcon color="primary" /> },
  { titulo: 'Ver mis evaluaciones', ruta: '/mis-evaluaciones', icono: <FolderSharedIcon color="primary" /> },
  { titulo: 'Ver las evaluaciones de mi equipo', ruta: '/equipo-evaluaciones', icono: <ChecklistIcon color="primary" /> },
  { titulo: 'Ver todas las evaluaciones', ruta: '/todas-las-evaluaciones', icono: <InsightsIcon color="primary" /> },
  { titulo: 'Calibrar Evaluaciones', ruta: '/calibrar-evaluaciones', icono: <TuneIcon color="primary" /> },
  { titulo: 'Análisis de tendencias', ruta: '/tendencias', icono: <BarChartIcon color="primary" /> },
  { titulo: 'Progreso de objetivos', ruta: '/objetivos', icono: <TrackChangesIcon color="primary" /> },
  { titulo: 'Ver Comentarios', ruta: '/comentarios', icono: <CommentIcon color="primary" /> },
];

export default function EvaluacionesHome() {
  const navigate = useNavigate();

  return (
    <Box p={4} sx={{ maxWidth: 1100, margin: '0 auto' }}>
      <Typography variant="h5" sx={{ mb: 3, color: '#1C2A44' }}>
        Evaluaciones de Desempeño
      </Typography>
      <Grid container spacing={2}>
        {acciones.map((accion, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Card
              variant="outlined"
              sx={{
                height: '100%',
                borderColor: '#e0e0e0',
                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.08)',
                '&:hover': {
                  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
                }
              }}
            >
              <CardActionArea onClick={() => navigate(accion.ruta)}>
                <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={{ mr: 2 }}>{accion.icono}</Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 500, color: '#1C2A44' }}>
                    {accion.titulo}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
